/* eslint-disable */
import { createSelector } from 'reselect';
import { MODULE_NAME } from '../constants';

export const moduleState = state => state[MODULE_NAME];

export const voucherCode = createSelector(
    moduleState,
    v => v.voucher.data.code
);

export const voucherOwner = createSelector(
    moduleState,
    v => v.voucher.data.owner
);

export const voucherList = createSelector(
    moduleState,
    v => v.voucher.data.list
);
